<template>
    <app-layout-new :title="form.title + ' - Tour Details'" :publishTour="publishTour" :visibility="$page.props.tour.data.visibility" :showVisibility=true :changeVisibility="changeVisibility" :update="updateTour" :form="form" :publish_tour_form="publish_tour_form">

        <template v-slot:left-area>
            <div class="p-2 flex justify-between">
                <h3 class="text-white text-xl font-bold uppercase">Stations</h3>
                <i class="arrow-down mt-1"></i>
            </div>
            <left-area-stations :changeLanguage="changeLanguage" />
        </template>

        <div class="flex lang-box">
            <a v-for="(lang, index) in languages" href="#" @click.prevent="changeLanguage(lang)" :key="index"
            :class="{active:(form.current_language == lang)}">{{ showFallbackLang(lang) }}</a>
        </div>

        <section class="border border-gray-800 p-3">
            <h3 class="text-white text-2xl font-bold uppercase">General</h3>

            <div class="flex">
                <label>Title</label>
                <span v-if="errors.title" class="errormessage">{{ errors.title }}</span>
            </div>
            <input class="input-black" type="text" v-model="form.title">

            <div class="flex">
                <label>Subtitle</label>
                <span v-if="errors.subtitle" class="errormessage">{{ errors.subtitle }}</span>
            </div>
            <input class="input-black" type="text" :value="form.subtitle" disabled>

            <button  @click.prevent="toggleCollapsibleMeasurements" class="my-3 btn btn-gradient">{{ this.show }} measurements</button>
            <div v-show="!collapsed">
                <div class="flex">
                    <label>Length in Minutes</label>
                    <span v-if="errors.length_minutes" class="errormessage">{{ errors.length_minutes }}</span>
                </div>
                <input class="input-black" type="text" v-model="form.length_minutes">

                <div class="flex">
                    <label>Length in Meter</label>
                    <span v-if="errors.length_meter" class="errormessage">{{ errors.length_meter }}</span>
                </div>
                <input class="input-black" type="text" v-model="form.length_meter">

                <div class="flex">
                    <label>Radius in Meter</label>
                    <span v-if="errors.radius_in_meter" class="errormessage">{{ errors.radius_in_meter }}</span>
                </div>
                <input class="input-black" type="text" v-model="form.radius_in_meter">
            </div>

        </section>

        <section class="border border-gray-800 p-3">
            <div class="grid grid-cols-4 grid-flow-col gap-2">
                <TourUploadBox name="Tour Logo" type="logo_file"
                :form="form"
                :changeUploadBoxState="changeUploadBoxState"
                uploadPlace="tour-logo"
                :current_language="form.current_language"
                :changeLanguage="changeLanguage"
                :showPreventFallbackLangModal="showPreventFallbackLangModal"
                :deleteInAllLanguagesFormRunning="deleteInAllLanguagesFormRunning"
                :hidePreventFallbackLangModal="hidePreventFallbackLangModal"
                />

                <TourUploadBox name="Tour preview image" type="preview_file"
                    :form="form"
                    :changeUploadBoxState="changeUploadBoxState"
                    uploadPlace="tour-image"
                    :current_language="form.current_language"
                    :changeLanguage="changeLanguage"
                    :showPreventFallbackLangModal="showPreventFallbackLangModal"
                    :deleteInAllLanguagesFormRunning="deleteInAllLanguagesFormRunning"
                    :hidePreventFallbackLangModal="hidePreventFallbackLangModal"
                    />

                    <PreventFallbackLanguageModal
                    :showModal="preventFallbackLanguageModalShow"
                    :hideModalFn="hidePreventFallbackLangModal"
                    :runDeleteInAllLanguagesForm="runDeleteInAllLanguagesForm"
                    :deleteInAllLanguagesFormRunning="deleteInAllLanguagesFormRunning"
                    :deleteInAllLanguagesCoordinateDataFormRunning="deleteInAllLanguagesCoordinateDataFormRunning"
                    :preventFallbackLanguageModalContext="preventFallbackLanguageModalContext"
                />

            </div>
        </section>

        <Design
        :form="form.design"
        />

        <CoordinateData
        :changeUploadBoxState="changeUploadBoxState"
        :form="coordinates_data_form"
        :waypoints="waypoints"
        :errors="errors"
        :current_language="form.current_language"
        :fallback_language="form.fallback_language"
        :changeLanguage="changeLanguage"
        :showPreventFallbackLangModal="showPreventFallbackLangModal"
        :deleteInAllLanguagesCoordinateDataFormRunning="deleteInAllLanguagesCoordinateDataFormRunning"
        :hidePreventFallbackLangModal="hidePreventFallbackLangModal"
        />


        <div class="mb-10 mt-10">
            <button v-if="!form.processing" @click.prevent="updateTour" class="btn btn-gradient mt-2 mb-10">
                {{ form.recentlySuccessful ? __('updated') :__('update') }}
            </button>
            <button v-else class="btn btn-gradient opacity-75 mt-2 mb-10" disabled><Spinner class="float-left mr-1"/>{{ __('updating') }}</button>
        </div>

        <MediaLibrary
            :uploadBoxState="uploadBoxState"
            :changeUploadBoxState="changeUploadBoxState"
            :select="selectFileFromMediaLibrary"
        />

    </app-layout-new>

</template>

<script>
import AppLayoutNew from '@/Layouts/AppLayoutNew.vue';
import LeftAreaStations from '@/UI/LeftAreaStations';
import TourUploadBox from './Partials/TourUploadBox';
import MediaLibrary from '@/Pages/Media/MediaLibrary';
import Spinner from '@/UI/Spinner';
import { changeUploadBoxState, selectFileFromMediaLibrary } from '@/Pages/Media/MediaLibraryLogic.js';
import CoordinateData from './Partials/CoordinateData/CoordinateData';
import Design from './Partials/Design';
import { showFallbackLang } from '@/Pages/GlobalHelpers';
import PreventFallbackLanguageModal from '@/Modals/PreventFallbackLanguageModal';
import {
    showPreventFallbackLangModal,
    hidePreventFallbackLangModal,
    runDeleteInAllLanguagesForm
} from '@/Pages/GlobalHelpers';
import { __ } from '@/locale';

export default {
    components: {
        AppLayoutNew,
        LeftAreaStations,
        TourUploadBox,
        MediaLibrary,
        Spinner,
        CoordinateData,
        PreventFallbackLanguageModal,
        Design,
    },
    props: {
      errors: Object,
    },
    data(){
        return{
            __,
            show: "show",
            collapsed: true,
            tour_identifier: this.$page.props.tour.data.identifier,
            languages: this.$page.props.tour.data.languages,
            form: this.$inertia.form({
                _method: 'POST',
                title: null,
                subtitle: null,
                length_minutes: null,
                length_meter: null,
                radius_in_meter: null,
                current_language: null,
                fallback_language: this.$page.props.tour.data.fallback_language,
                tour_files: {
                    preview_file: {
                        file_type: 'image',
                        file: null,
                        copyright_link: '',
                        copyright_text: '',
                        loaded_file_path: '',
                        from_media_library_id: false,
                    },
                    logo_file: {
                        file_type: 'image',
                        file: null,
                        copyright_link: '',
                        copyright_text: '',
                        loaded_file_path: '',
                        from_media_library_id: false,
                    },
                },
                design: {
                    header_font: 'arial',
                    header_text_color: '#FFFFFF',
                    header_background_color: '#FFFFFF',
                    content_font: 'arial',
                    content_text_color: '#FFFFFF',
                    content_background_color: '#FFFFFF',
                },
            }),
            publish_tour_form: this.$inertia.form({
                _method: 'POST',
            }),
            toggle_visibility_form: this.$inertia.form({
                _method: 'POST',
            }),
            uploadBoxState: null,
            waypoints: this.$page.props.tour.data.waypoints,
            coordinates_data_form: this.$inertia.form({
                _method: 'POST',
                coordinates_data: this.initialCoordinatesData(),
                current_language: null,
            }),
            //prevent modal in fallback language
            preventFallbackLanguageModalShow: false,
            deleteInAllLanguagesFormRunning: false,
            deleteInAllLanguagesCoordinateDataFormRunning: false,
            preventFallbackLanguageModalContext: null,
        }
    },
    mounted(){
        this.changeLanguage(this.$page.props.tour.data.fallback_language);
    },
    methods: {
        updateTour(){
            this.form.post(route('tour.update', this.tour_identifier), {
              preserveScroll: true,
              onSuccess: () => {
                this.changeLanguage(this.$page.props.tour.data.fallback_language);
              },
              onError: (err) => {}
            });
        },
        changeLanguage(lang){
            this.clearErrors();
            this.form.current_language = lang;
            this.coordinates_data_form.current_language = lang;
            this.form.title = this.$page.props.tour.data.title.localized_text[lang];
            this.form.subtitle = this.$page.props.tour.data.subtitle.localized_text[lang];
            this.form.length_minutes = this.$page.props.tour.data.length_minutes;
            this.form.length_meter = this.$page.props.tour.data.length_meter;
            this.form.radius_in_meter = this.$page.props.tour.data.radius_in_meter;
            this.form.tour_files.logo_file.loaded_file_path = (this.$page.props.tour.data.logo && this.$page.props.tour.data.logo.filter(el=> el.language == lang).length)
            ? this.$page.props.tour.data.logo.filter(el=> el.language == lang)[0]['first_file_path'] : null;
            this.form.tour_files.preview_file.loaded_file_path = (this.$page.props.tour.data.image && this.$page.props.tour.data.image.filter(el=> el.language == lang).length)
            ? this.$page.props.tour.data.image.filter(el=> el.language == lang)[0]['first_file_path'] : null;
            this.form.tour_files.preview_file.file = null;
            this.form.tour_files.logo_file.file = null;
            this.form.tour_files.preview_file.from_media_library_id = false;
            this.form.tour_files.logo_file.from_media_library_id = false;
            this.coordinates_data_form.coordinates_data = this.initialCoordinatesData();
            this.waypoints = this.$page.props.tour.data.waypoints;

        },
        publishTour(){
            this.publish_tour_form.post(route('tour.publish', this.tour_identifier), {
              preserveScroll: true,
              onSuccess: () => this.changeLanguage(this.form.current_language),
            });
        },
        onFilePicked(event, files, type){
            if(this.$page.props.tour.data.fallback_language != this.form.current_language)
            {
                //Validate Tour Logo existing Language
                if(this.$page.props.tour.data.logo == null && type == 'logo_file')
                {
                    this.errors.logo_file = 'You need to add Tour Logo in Fallback language first';
                    event.target.value = '';
                    return;
                }
                //Validate Preview Image existing Language
                if(this.$page.props.tour.data.image == null && type == 'preview_file')
                {
                    this.errors.preview_file = 'You need to add Tour Preview Image in Fallback language first';
                    event.target.value = '';
                    return;
                }
            }
            //add the file
            this.form.tour_files[type].file = files[0];
            event.target.value = '';
        },
        changeVisibility() {
            this.toggle_visibility_form.post(route('tour.toggle-visibility', this.tour_identifier));
        },
        clearErrors(){
            this.errors.logo_file = null;
            this.errors.preview_file = null;
            this.errors.title = null;
            this.errors.subtitle = null;
            this.errors.coordinate_data = null;
            this.errors.languages = null;
        },
        toggleCollapsibleMeasurements() {
            this.collapsed = !this.collapsed;
            if(this.collapsed === false) {
                this.show = "hide";
            }
            if(this.collapsed === true) {
                this.show = "show";
            }
        },
        changeUploadBoxState: changeUploadBoxState,
        selectFileFromMediaLibrary: selectFileFromMediaLibrary,
        initialCoordinatesData(){
            return {
                thickness: 50,
                color: "#000000",
                loaded_file_path: '',
                from_media_library_id: false,
                current_waypoint_id: null,
            }
        },
        showFallbackLang:showFallbackLang,
        saveCoordinatesData(){
            this.coordinates_data_form.post(route('coordinate.store', this.tour_identifier), {
              preserveScroll: true,
              onSuccess: () => {
                this.changeLanguage(this.form.current_language)
              }
            });
        },
        showPreventFallbackLangModal:showPreventFallbackLangModal,
        hidePreventFallbackLangModal:hidePreventFallbackLangModal,
        runDeleteInAllLanguagesForm:runDeleteInAllLanguagesForm,
    },
    // computed: {
    //     humanReadableTourVisibility() {
    //         console.log(this.$page.props.tour.data.visibility);
    //         return this.$page.props.tour.data.visibility > 0 ? ' | (visible)' : ' | (invisible)';
    //     }
    // }
}
</script>
